export default {
  id: 158,
  title: 'Target #158 - Clubs',
  url: 'https://cssbattle.dev/play/158',
  colors: ['#4F77FF', '#1038BF'],
  solution:
    '<a a><a b><style>[a],[b]{left:150;width:100;height:100;background:#1038bf}body{background:#4f77ff}a{position:fixed}[a]{top:150}[b]{top:50;border-radius:9in;box-shadow:45px 70px #1038bf,-45px 70px #1038bf,55px 110px #4f77ff,-55px 110px #4f77ff}</style>',
}
